export async function downloadFile(
  url: string,
  filename: string,
  onError?: () => void,
) {
  try {
    // Fetch the file from the URL
    const response = await fetch(url);

    // Check if the response is OK (status 200-299)
    if (!response.ok) {
      throw new Error(`Failed to download file`);
    }

    // Convert the response to a Blob
    const blob = await response.blob();
    // Create a temporary URL for the Blob
    const blobUrl = URL.createObjectURL(blob);

    // Create an invisible anchor element
    const anchor = document.createElement('a');
    anchor.href = blobUrl;
    anchor.download = filename;
    // Trigger the download
    anchor.click();
    // Revoke the object URL after the download
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    onError?.();
  }
}
